import React, { useRef } from 'react';
import CompaniesHeroSection from '../../../components/landingPage/CompaniesPage/CompaniesHeroSection';
import CompaniesStatBand from '../../../components/landingPage/CompaniesPage/CompaniesStatBand';
import CompaniesLifecycleSection from '../../../components/landingPage/CompaniesPage/CompaniesLifecycleSection';
import CompaniesHowItWorks from '../../../components/landingPage/CompaniesPage/CompaniesHowItWorks';
import CompaniesPricingSection from '../../../components/landingPage/CompaniesPage/CompaniesPricingSection';
import CompaniesQuotesSection from '../../../components/landingPage/CompaniesPage/CompaniesQuotesSection';
import CompaniesCtaSection from '../../../components/landingPage/CompaniesPage/CompaniesCtaSection';
import { useReveal, useCountUp } from '../../../components/landingPage/common/landingHooks';
import AeoResourcesSection from '../../../components/landingPage/AeoArticles/AeoResourcesSection';
import useDocumentHead from '../../../components/landingPage/AeoArticles/useDocumentHead';
import hubWebPageSchema from '../../../components/landingPage/AeoArticles/aeoHubSchema';
import { AEO_HUBS } from '../../../components/landingPage/AeoArticles/aeoArticlesData';

// Kept for backwards compatibility with legacy imports (e.g. pricing plans backup)
export const COMPONENT_REF = ['banner-title', 'life-cycle-title', 'clinet-review-title', 'how-its-work-title', 'work-block-scaling', 'key-features', 'video-section-title', 'register-form-title', 'not-sure', 'pricing-title', 'pricing-section'];

const LandingHomeCompanies = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);
    useDocumentHead({ canonicalPath: `${AEO_HUBS['ceo']['hubPath']}/`, schema: hubWebPageSchema('ceo') });

    return (
        <div className="lp-page" ref={rootRef}>
            <CompaniesHeroSection />
            <CompaniesStatBand />
            <CompaniesLifecycleSection />
            <CompaniesHowItWorks />
            <CompaniesPricingSection />
            <CompaniesQuotesSection />
            <CompaniesCtaSection />
            <AeoResourcesSection icpSlug="ceo" />
        </div>
    );
};

export default LandingHomeCompanies;
